function getIdentityValues(value: any): string[] {
    return [
        value?.corid,
        value?.cor_id,
        value?.user_id,
        value?.id,
        value?.profile?.corid,
        value?.profile?.cor_id,
        value?.profile?.user_id,
        value?.profile?.id,
        value?.user?.corid,
        value?.user?.cor_id,
        value?.user?.user_id,
        value?.user?.id,
    ]
        .filter((identity) => identity !== undefined && identity !== null && String(identity) !== '')
        .map(String)
}

const getNormalizedEmail = (value: any) => String(
    value?.email
    ?? value?.profile?.email
    ?? value?.user?.email
    ?? '',
).trim().toLowerCase()

const usersHaveSameIdentity = (left: any, right: any) => {
    const leftIds = new Set(getIdentityValues(left))
    const hasSharedId = getIdentityValues(right).some((identity) => leftIds.has(identity))

    if (hasSharedId) {
        return true
    }

    const leftEmail = getNormalizedEmail(left)
    return Boolean(leftEmail && leftEmail === getNormalizedEmail(right))
}

export function isCommentOwnedByUser(comment: any, currentUser: any, knownUsers: any[] = []): boolean {
    const currentUserIds = new Set(getIdentityValues(currentUser))

    if (!currentUserIds.size && !getNormalizedEmail(currentUser)) {
        return false
    }

    const commentUserIds = getIdentityValues({
        corid: comment?.user_corid,
        cor_id: comment?.user_cor_id,
        user_id: comment?.user_id,
        id: comment?.created_by_id ?? comment?.author_id,
        user: comment?.user ?? comment?.author,
    })

    if (commentUserIds.some((identity) => currentUserIds.has(identity))) {
        return true
    }

    // Auth and Task Manager may expose different ids for the same person.
    // Resolve the current auth user through the task-user list (email/COR id),
    // then compare the comment author with that task-local identity.
    return knownUsers.some((knownUser) => (
        usersHaveSameIdentity(currentUser, knownUser)
        && commentUserIds.some((identity) => getIdentityValues(knownUser).includes(identity))
    ))
}
